import { LoadSkiaWeb } from "@shopify/react-native-skia/lib/module/web/LoadSkiaWeb";
import { CANVASKIT_VERSION } from "../../../constants/CANVASKIT_VERSION";

const SkiaWeb: {
	promise: Promise<void> | null;
	didLoad: boolean;
} = {
	promise: null,
	didLoad: false,
};

// If this URL gets 403/404'd, you likely just need to run it through CI to populate our WASM hosting
// Or run the `copyWasm` script in the React Native directory
const CANVASKIT_URL = `https://dnnqo5iczq5wf.cloudfront.net/wasm/canvaskit/${CANVASKIT_VERSION}/canvaskit.wasm`;
export const cachedLoadSkiaWeb = (): Promise<void> => {
	if (SkiaWeb.promise) return SkiaWeb.promise;
	SkiaWeb.promise = LoadSkiaWeb({
		locateFile: () => CANVASKIT_URL,
	}).then(() => {
		SkiaWeb.didLoad = true;
	});
	return SkiaWeb.promise;
};
export const didLoadSkiaWeb = (): boolean => SkiaWeb.didLoad;

const prefetchSkia = async (): Promise<void> => {
	await cachedLoadSkiaWeb();
};
export default prefetchSkia;
